<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-20 10:27:47
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-02 14:56:38
 * @FilePath: /wemeet-admin-new/src/views/exhibitionManage/components/couponUse.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <vab-query-form class="ml-10">
      <vab-query-form-right-panel :span="24">
        <el-form :model="form">
          <el-form-item label="手机号">
            <el-input v-model="form.phone" />
            <el-button style="margin-left: 10px" type="primary" @click="handleQueryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <div class="containerForm">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="姓名" prop="name" />
        <el-table-column label="手机号" prop="mobile" />
        <el-table-column label="使用时间">
          <template #default="{ row }">
            {{ row.useTime ? handleDate(row.useTime) : '暂无' }}
          </template>
        </el-table-column>

        <!-- <el-table-column label="状态">
          <template #default="{ row }">
            {{ filterSelectStatus[row.status] }}
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        background
        :current-page="form.pageNum"
        :layout="layout"
        :page-size="form.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>
    <!-- <div class="demo-drawer__footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">提交</el-button>
    </div> -->
  </el-drawer>
  <!-- <el-dialog v-model="visible" title="提示">
    <p>因我方运营需求，需要生成并导出用户信息。导出的用户信息仅用于运营用途，我方承诺不会泄露用户隐私。如有泄露或造成纠纷，我方会承担相应法律责任。</p>
    <el-checkbox v-model="isCheck" label="请勾选确认" size="large" />
    <template #footer>
      <el-button type="primary" @click="handleExport(checkRow, 'N')"> 导出脱敏信息</el-button>
      <el-button type="primary" @click="handleExport(checkRow, 'Y')"> 导出完整信息</el-button>
    </template>
  </el-dialog> -->
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { queryDiscountCode } from '@/api/exhibitionManage'
  import { parseTime } from '@/utils/index'
  export default defineComponent({
    name: 'EditConfigDrawer',

    setup(props, { emit }) {
      /**
       * @description: cover主k 自定义校验
       * @return {*}
       */

      const { proxy } = getCurrentInstance()
      const state = reactive({
        form: {
          pageNum: 1,
          pageSize: 10,
          phone: '',
        },
        filterSelectStatus: {
          WAIT_USED: '待使用',
          USED: '已使用',
          ING_USED: '进行中',
        },
        dialogFormVisible: false,
        direction: 'rtl',
        size: '40%',
        pararms: {
          type: 'MEETING_REGISTER_REPORT',
        },
        title: '优惠码使用明细',
        tableData: [],
        isCheck: false,
        visible: false,
        checkRow: {},
        total: 0,
        list: [],
        layout: 'prev, pager, next',

        // exportLoading: false,
      })

      // 打开
      const handleOpen = async (row = {}) => {
        state.form = Object.assign(state.form, row)
        state.dialogFormVisible = true
        getData()
      }

      const getData = async () => {
        const { data } = await queryDiscountCode(state.form, state.form.code)
        console.log(data)
        state.tableData = data.list
        state.total = data.total
      }
      // 关闭
      const handleClose = () => {
        state.dialogFormVisible = false
      }

      const exportFile = (row) => {
        window.open(row.exportParams.fileUrl)
      }
      const handleDate = (val) => {
        return parseTime(val)
      }

      // 查询
      const handleQueryData = () => {
        state.form.pageNum = 1
        getData()
      }
      // 条数
      const handleSizeChange = (pageSize) => {
        state.form.pageSize = pageSize
        getData()
      }

      const handleCurrentChange = (pageNum) => {
        state.form.pageNum = pageNum
        getData()
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        exportFile,
        handleDate,
        handleQueryData,
        handleSizeChange,
        handleCurrentChange,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    width: 100%;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
</style>
